import { MuiOtpInput } from 'mui-one-time-password-input';
import { isString } from 'lodash';
import { useTheme } from '@mui/material';
import { DEFAULT_OTP_LENGTH } from '../../consts/constants';

interface IOtpBoxes {
  otp: string;
  onChange: any;
  variant?: 'default' | 'hale';
}

function validateChar(text: string, index: number) {
  const isNumber = typeof text === 'number';
  const isStr = isString(text);
  return (isNumber || (isStr && text !== '')) && !isNaN(Number(text));
}
const OtpBoxes = ({ otp, onChange, variant = 'default' }: IOtpBoxes) => {
  const theme = useTheme();
  const isHaleVariant = variant === 'hale';

  return (
    <>
      <MuiOtpInput
        TextFieldsProps={{
          inputProps: {
            inputMode: 'numeric',
            pattern: '[0-9]*',
          },
          size: 'medium',
        }}
        sx={{
          '.MuiOtpInput-TextField': {
            '& .MuiOutlinedInput-root': {
              borderRadius: isHaleVariant ? '12px' : theme.custom.borderRadius.medium,
              background: isHaleVariant ? '#f8fafc' : theme.palette.background.black_1200,
              color: isHaleVariant ? '#0f172a' : theme.palette.text.elevenary,
              width: theme.custom.width['3_5'],
              '& input': {
                color: isHaleVariant ? '#0f172a' : theme.palette.text.elevenary,
                gap: theme.custom.gap.small,
                borderRadius: isHaleVariant ? '12px' : theme.custom.gap.medium,
                opacity: '0px',
                height: theme.custom.height['1_375'],
                padding: `${theme.custom.padding.medium} 0`,
                border: isHaleVariant
                  ? '2px solid #e2e8f0'
                  : `0.063rem solid ${theme.custom.customColors['GREY_900']}`,
                fontSize: theme.typography.textSize.mediumX,
                fontWeight: theme.typography.fontWeight.medium,
                fontFamily: isHaleVariant ? 'Inter, sans-serif' : undefined,
              },
            },
            '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: isHaleVariant
                ? '2px solid #CBA052'
                : `0.063rem solid ${theme.palette.secondary.quaternary}`,
            },
          },
        }}
        length={DEFAULT_OTP_LENGTH}
        value={otp}
        validateChar={validateChar}
        onChange={(value: string) => onChange(value)}
      />
    </>
  );
};

export default OtpBoxes;
